import { MarkType } from '@const/consts'
import { IPrepositionMarks } from '@store/modules/shared/types'

export const setFullNameMarks = (
  marks: IPrepositionMarks,
  fullName: string,
): IPrepositionMarks => Object.fromEntries(
  Object.entries(marks).map(([key, mark]) => [
    key,
    mark.type === MarkType.FULLNAME ? {...mark, value: fullName} : mark,
  ]),
)

export const excludeFullNameMarks = (
  marks: IPrepositionMarks,
): IPrepositionMarks => Object.fromEntries(
  Object.entries(marks).filter(([, mark]) => mark.type !== MarkType.FULLNAME),
)
